import { Typography } from '@ghq-abi/design-system-v2';

type PageHeadingProps = {
  children: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
};

export function PageHeading({
  children,
  as = 'h1',
  className = ''
}: PageHeadingProps) {
  return (
    <Typography
      as={as}
      variant="subtitle-lg-medium"
      className={`mb-4 text-gray-700 flex items-center ${className}`}>
      {children}
    </Typography>
  );
}
